import { SsoProviderType as p } from "./account.js";
var c = /* @__PURE__ */ ((i) => (i.Click = "click", i.Reach = "reach", i.Trigger = "trigger", i.Login = "login", i.SignUp = "sign_up", i.ConsentUpdate = "consent_update", i))(c || {});
const s = {
  [p.SKY_MAVIS]: "Sky Mavis",
  [p.GOOGLE]: "Google",
  [p.TWITTER]: "Twitter",
  [p.APPLE]: "Apple",
  [p.DISCORD]: "Discord",
  [p.Unspecified]: "Unspecified"
};
export {
  c as GASharedEventCategory,
  s as GASsoProviderMapping
};
//# sourceMappingURL=googleAnalytics.js.map
